var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPenSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.586 0.610576C10.7705 0.419556 10.9912 0.267191 11.2352 0.162373C11.4792 0.0575555 11.7416 0.00238315 12.0072 7.55134e-05C12.2728 -0.00223212 12.5361 0.0483713 12.7819 0.148933C13.0277 0.249495 13.251 0.398001 13.4388 0.585786C13.6266 0.773572 13.7751 0.996876 13.8756 1.24267C13.9762 1.48846 14.0268 1.75182 14.0245 2.01738C14.0222 2.28294 13.967 2.54538 13.8622 2.78939C13.7574 3.03339 13.605 3.25408 13.414 3.43858L12.621 4.23158L9.793 1.40358L10.586 0.610576ZM8.379 2.81758L0 11.1966V14.0246H2.828L11.208 5.64558L8.378 2.81758H8.379Z",
    fill: "#C64641"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenSvg);
export default __webpack_public_path__ + "static/media/pen_svg.3ca2fb293b576e3789b97b6c3595aace.svg";
export { ForwardRef as ReactComponent };